<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<div class="setHeightFullGrey paddingbottom50" style="background: #eee;">
			<van-swipe :autoplay="1500" indicator-color="white">
				<van-swipe-item v-for="(item, index) in imgs" :key="index">
					<div style="position: relative;">
						<van-image height="275px" :src="item.img" fit="cover" @click="go(item.path)"></van-image>
						<div style="color: #fff;font-size: 16px;position: absolute;bottom: 0px;background: rgba(0,0,0,0.3);width: 100%;padding:5px 0;text-align: center;">{{item.title}}</div>
					</div>
				</van-swipe-item>
			</van-swipe>
			<div v-for="(item,index2) in hpInfo" class="marginBottomXm setWhite" :key="index2">
				<van-card :desc="item.titleSub" :title="item.title" :thumb="item.img" centered @click="go(item.path)">
					<div slot="tags" v-if="item.date">
						<van-tag type="success">{{item.date}}</van-tag>
					</div>
				</van-card>
			</div>
		</div>
		<!-- 底部tab -->
		<myFoot></myFoot>
		<!-- 返回顶部 -->
		<backTop ref="bt"></backTop>
	</joy-page>
</template>

<script>
	export default {
		data() {
			return {
				hpInfo: [],
				imgs: [],
				joyPageStatus: '',
			}
		},
		methods: {
			go(name) {
				window.open(name);
			},
			loadData() {
				try {
					this.$axios.get('/partner/style').then((res) => {
						this.joyPageStatus = 'success';
						let data = res.data;
						if(data.code==200){
							for (let i in data.data.style_list) {
								data.data.style_list[i].img = 'http://img.jiarixiaodui.com/' + data.data.style_list[i].img;
								if (data.data.style_list[i].top == 1) {
									this.imgs.push(data.data.style_list[i]);
								}
							};
							this.hpInfo = data.data.style_list;
						}else{
							
						}
						
					}).catch(function(error) {
						this.joyPageStatus = 'fail';
					});
				} catch (e) {
					if (this.$Util.debug) {
						console.log(e);
					};
				}
			}
		},
		created() {
			this.loadData();
			let config={
			        title:'假日伙伴风采',
			}
			this.wxShare(config);
		},
	}
</script>

<style scoped="scoped">
	.partnerStyle {
		background: #eee;
	}
</style>
